import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close3",
  "use": "icon-close3-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-close3\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M4 4h16v16H4z\" /><path d=\"M0 0h24v24H0z\" /><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M19.071 4.929a1 1 0 0 1 0 1.414L6.343 19.071a1 1 0 0 1-1.414-1.414L17.657 4.929a1 1 0 0 1 1.414 0z\" /><path d=\"M19.071 19.071a1 1 0 0 1-1.414 0L4.929 6.343A1 1 0 0 1 6.343 4.93l12.728 12.728a1 1 0 0 1 0 1.414z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol